import { EuroCents } from '@shared/domain/euro-cents'

export const sum = (xs: EuroCents[]): EuroCents => xs.reduce((p, c) => c.add(p), EuroCents.zero())
